import { IColumn } from '../types';
import { defaultHeaderRenderer } from '../headers';
import { CellEventsHandler } from '../formatters';
import { CellProps } from '../../types';
import { OverflowedText } from '../../../../../utilities/overflowedText';

const ServicesFormatter = (cellProps: CellProps) => {
  if (!cellProps.row?.partners?.length) {
    return <CellEventsHandler cellProps={cellProps}>None</CellEventsHandler>;
  }
  return (
    <CellEventsHandler cellProps={cellProps}>
      <OverflowedText theme={{ lines: 4 }}>{cellProps.row.partners.join(', ')}</OverflowedText>
    </CellEventsHandler>
  );
};

export const ServicesColumn = (): IColumn => ({
  item: {
    key: 'partners',
    name: 'Services',
    headerRenderer: defaultHeaderRenderer,
    sortable: true,
    width: 'minmax(112px, 1fr)',
    formatter: ServicesFormatter,
  },
  visible: ({ isServicesVisible }) => isServicesVisible!,
});
